<template>
  <div>
    <el-dialog
      title="摘牌支付"
      v-loading.fullscreen.lock="loading"
      :visible="delistingShow"
      :close-on-click-modal="false"
      width="60%"
      @close="close"
    >
      <div class="dia_wrap">
        <el-form
          class="form"
          ref="formRef"
          :model="formData"
          :rules="rules"
          label-position="left"
          label-width="110px"
          size="mini"
        >
<!--          <div class="h_bg p50">-->
<!--            <h3>选择摘牌方式</h3>-->
<!--          </div>-->
<!--          <div class="m50">-->
<!--            <el-radio-group v-model="formData.payType" @change="payMoneyEvt">-->
<!--              <el-radio :label="1">全额付款</el-radio>-->
<!--              <el-radio :label="2" :disabled="!data.advancePaymentAmount"-->
<!--                >预付款</el-radio-->
<!--              >-->
<!--              &lt;!&ndash; <el-radio :label="2">预付款</el-radio> &ndash;&gt;-->
<!--              <div style="display: inline-block; margin-left: 20px">-->
<!--                <el-radio :label="3" v-if="applyStatus == 1"-->
<!--                  >交付后再付</el-radio-->
<!--                >-->
<!--                <el-radio :label="4" v-if="applyStatus == 1">其他</el-radio>-->
<!--                <el-button-->
<!--                  v-if="applyStatus != -1 && applyStatus != 1"-->
<!--                  type="primary"-->
<!--                  :disabled="applyStatus === 0"-->
<!--                  size="mini"-->
<!--                  @click="upDia = true"-->
<!--                  >申请其他方式</el-button-->
<!--                >-->
<!--              </div>-->
<!--              <el-input-->
<!--                style="width: 170px; margin-left: 10px"-->
<!--                v-if="formData.payType == 4"-->
<!--                v-model="formData.payInfo"-->
<!--                placeholder="请输入"-->
<!--                size="mini"-->
<!--              ></el-input>-->
<!--            </el-radio-group>-->
<!--          </div>-->
          <div class="transfer_wrap" v-if="isPromisePayed != 1">
            <div
              class="pop"
              v-show="formData.payType == 3 || formData.payType == 4"
            ></div>
            <div class="h_bg p50">
              <h3>转账信息</h3>
              <span>请根据以下银行信息进行缴费，缴费完成后，上传缴费凭证</span>
            </div>
<!--            <div class="demo-input-suffix p50" v-if="data.tranferType == 1">-->
<!--              <span v-if="isPromisePayed == 0" style="margin-right: 20px"-->
<!--                >交易保证金(元)</span-->
<!--              >-->
<!--              <span v-if="isPromisePayed == 0" class="redF">{{-->
<!--                data.tranferEnsureAmount-->
<!--              }}</span>-->
<!--            </div>-->
<!--            <div class="demo-input-suffix p50" v-else>-->
<!--              <span style="margin-right: 20px">{{-->
<!--                formData.payType == 1-->
<!--                  ? "投资金额"-->
<!--                  : formData.payType == 2-->
<!--                  ? "预付款"-->
<!--                  : "支付金额"-->
<!--              }}</span>-->
<!--              <span class="redF"-->
<!--                >{{-->
<!--                  formData.payType == 1-->
<!--                    ? data.amount-->
<!--                    : formData.payType == 2-->
<!--                    ? data.advancePaymentAmount-->
<!--                    : "0.00"-->
<!--                }}元</span-->
<!--              >-->
<!--            </div>-->
<!--            <div class="p50">-->
<!--              <div class="mb10">-->
<!--                <span class="wid">实际支付金额（元）</span>-->
<!--                <span class="redF">{{ payAmount }}</span>-->
<!--              </div>-->
<!--              <div class="mb10">-->
<!--          <span class="wid">{{-->
<!--              formData.payType == 1-->
<!--                ? "投资金额"-->
<!--                : formData.payType == 2-->
<!--                ? "预付款"-->
<!--                : "支付金额"-->
<!--            }}</span>-->
<!--                <span>{{-->
<!--                    formData.payType == 1-->
<!--                      ? data.amount-->
<!--                      : formData.payType == 2-->
<!--                      ? data.advancePaymentAmount-->
<!--                      : "0.00"-->
<!--                  }}</span>-->
<!--              </div>-->
<!--              <div class="mb10">-->
<!--                <span class="wid">交易服务费（元）</span>-->
<!--                <span>{{ transactionAmount }}</span>-->
<!--              </div>-->
<!--            </div>-->
            <div class="p50">
              <div class="mb10">
                <span class="wid">付款方式</span>
                <span>{{data.paymentMethod}}</span>
              </div>
              <div class="mb10">
                <span class="wid">成交价款（元）</span>
                <span>{{transactionPrice}}</span>
              </div>
              <div class="mb10">
                <span class="wid">交易服务费（元）</span>
                <span>{{ transactionAmount }}</span>
              </div>
              <div class="mb10">
                <span class="wid">应付金额（元）</span>
                <span class="redF">{{payAmount}}</span>
              </div>
            </div>
            <div class="radio-group-wrap p50">
              <el-radio-group
                v-model="formData.payMethod"
                :disabled="formData.payType == 3 || formData.payType == 4"
              >
                <el-radio label="2">自行转账</el-radio>
                <el-radio label="1">代收代付</el-radio>
              </el-radio-group>
            </div>
            <div class="content-group p50">
              <div
                class="group-tyep"
                :class="{ active: formData.payMethod == 2 }" v-if="formData.payMethod == 2"
              >
                <el-form-item label="开户银行">{{ openBank }}</el-form-item>
                <el-form-item label="账户名">{{ accountName }}</el-form-item>
                <el-form-item label="账号">{{ bankAccount }}</el-form-item>
                <div style="margin: 10px 0">
                  <div
                    v-for="(item, index) in formData.payEvidences"
                    :key="index"
                  >
                    <span v-if="item.url" class="imgWrapss">
                      <el-image
                        :src="item.url"
                        style="width: 200px; height: 150px"
                      ></el-image>
                      <i
                        @click.prevent.stop="
                          formData.payEvidences.splice(index, 1)
                        "
                        class="el-icon-delete"
                      ></i>
                    </span>
                  </div>
                  <Upload
                    v-model="fileUrl"
                    buttonText="上传缴费凭证（必填)"
                    @fileNameEvt="payFileNameEvt"
                    :size="true"
                  ></Upload>
                </div>
                <div v-if="data.tranferType == 1">
                  <p>请补充以下银行信息，以便于保证金退还使用</p>
                  <el-form-item label="银行账户">
                    <div class="flex_auto">
                      <el-select
                        v-model="formData.bankAccount"
                        @change="changeSelectBank()"
                      >
                        <el-option
                          v-for="item in bankList"
                          :key="item.bankCard"
                          :label="item.openBank"
                          :value="item.bankCard"
                        ></el-option>
                      </el-select>
                      <el-button
                        @click="$router.push({ name: 'managementPersonal' })"
                        style="margin-left: 15px"
                      >
                        添加银行卡</el-button
                      >
                    </div>
                  </el-form-item>
                  <el-form-item label="开户银行">
                    <el-input
                      v-model="formData.openBank"
                      placeholder="请输入开户银行"
                      disabled
                    ></el-input>
                  </el-form-item>
                  <el-form-item label="银行行号">
                    <el-input
                      v-model="formData.bankCode"
                      placeholder="请输入银行行号"
                    ></el-input>
                  </el-form-item>
                </div>
              </div>
              <div class="group-tyep" :class="{'active': formData.payMethod == 1, 'right-active': formData.payMethod == 1}" v-if="formData.payMethod == 1">
                <el-form ref="formData" label-position="left" size="mini">
                  <el-form-item label="银行账户" prop="bankAccount">
                    <div class="flex_auto">
                      <el-select v-model="formData.payBankAccount" @change="changeSelectBank('pay')">
                        <el-option v-for="item in bankList" :key="item.bankCard" :label="`${item.bankName}(${item.bankCard.slice(-4)})`" :value="item.bankCard"></el-option>
                      </el-select>
                      <el-button @click="$router.push({name:'managementPersonal'})" style="margin-left: 10px;"> 添加银行卡</el-button>
                    </div>
                  </el-form-item>
                  <div>
                    <el-checkbox v-model="checked"></el-checkbox>
                    我已阅读，并同意
                    <el-link v-if="formData.userType == 1" style="color: rgb(4, 126, 255)" :underline="false" href="http://fdfs.whdev.vpclub.cn/group1/M00/01/2F/wKgACmMiwvCALLMNAAHGsdnGZ4I262.pdf" target="_blank">《个人付款授权协议》</el-link>
                    <el-link v-else style="color: rgb(4, 126, 255)" :underline="false" href="http://fdfs.whdev.vpclub.cn/group1/M00/01/2F/wKgACmMiwx6AHCjYAAHFqH6Bgu8140.pdf" target="_blank">《企业付款授权协议》</el-link>
                  </div>
                </el-form>
              </div>

            </div>
          </div>
        </el-form>
      </div>
      <div slot="footer" class="btn">
        <el-button @click="close">取 消</el-button>
        <el-button class="sumbit" @click="newSaveAndSubmitBtn()"
          >确认提交</el-button
        >
      </div>
    </el-dialog>
    <Dialog :show="applayShow" @dialogClose="applayShow=false" :img="'success.png'" :title="'温馨提示'" content="摘牌成功" :btn="'返回'" btn2="查看我的投资" />
    <!-- 转账提示 -->
    <paySure :pay.sync="payInfoSure"  @operateSureEvt="operateSureEvt"> </paySure>
    <faceQrcode v-if="qrShow" ref="qr" @notify="notify"></faceQrcode>
  </div>
</template>

<script>
import Upload from "@/components/Upload/UpLoad.vue";
import Dialog from '@/components/Dialog';
import faceQrcode from '@/components/faceQrcodes/index.vue'
import publicFunction from "@/utils/publicFunction";
import paySure from '@/components/paySure/index.vue'
export default {
  props: {
    delistingShow: {
      type: Boolean,
      default: false,
    },
    data: {
      type: Object,
      default: "",
    },
    delistingData: {
      type: Object,
      default: "",
    },
  },
  components: {
    Upload,
    Dialog,
    paySure,
    faceQrcode
  },
  data() {
    return {
      qrShow: false,
      checked: true,
      transactionAmount: null,
      transactionPrice: null,
      payAmount: 0,
      loading: false,
      applayShow: false,
      formData: {
        payType: 1,
        payMethod: "2", // 1 代收代付  2 自行转账
        bankAccount: "", //银行账户 （必填）
        openBank: "", //开户银行
        bankCode: "", //银行行号
        amount: "", //
        payInfo: "",
        payEvidences: [], //支付凭证
        creditCode: "", //统一信用代码
        fileList: [],
        cloudPayId: "",
        payBankAccount: "",
        payBankName: "",
        areaId: "",
        feeType: "",
        callbackId: "",
      },
      openBank: "",
      accountName: "",
      bankAccount: "",
      rules: {},
      fileList: [],
      isPromisePayed: 0,
      fileUrl: "",
      fileNameS: "",
      applyStatus: -1, // 是否展示其他支付方式
      bankList: [], //代收代付银行卡列表
      payInfoSure:{
        accountName: '',
        bankAccount: '',
        amount: '',
      },
    };
  },
  mounted() {
  },
  methods: {
    notify(v) {
      this.qrShow = false
      if (v) {
        this.formData.callbackId = this.$refs.qr.callbackId
        setTimeout(() => {
          this.operateEvt()
        }, 500)
      }
    },
    operateSureEvt() {
      if (this.formData.payMethod == 1) {
        this.qrShow = true
        this.$nextTick(()=>{
          this.$refs.qr.sumbit()
        })
      } else {
        this.operateEvt()
      }
    },
    operateEvt(){
      this.loading = true
      this.$api.my.delistingOperate(this.formData).then((res) => {
        this.loading = false
        if(res.code == 1000){
          this.applayShow = true
          this.close()
          // this.$message.success("摘牌成功")
          // setTimeout(() => {
          //   this.close()
          //   this.$router.push({name: 'myInvest'})
          // },500)

        }
      }).finally(() => {
        this.loading = false
      });
    },
    //获取代收代付银行卡
    async getBankList() {
      this.bankList = [];
      await this.$api.user
          .getMyCard({
            // type: this.formData.userType == "2" ? 4 : this.formData.userType,
          })
          .then((res) => {
            if (res.code == 1000 && res.data && res.data.length) {
              this.bankList = res.data;
              if (res.data && res.data.length) {
                this.bankList.forEach((item) => {
                  if (item.isDefault == 1) {
                    this.formData.bankAccount = this.formData.payBankAccount =
                        item.bankCard; //银行账户 （必填）
                    this.formData.openBank = this.formData.payBankName =
                        item.bankName; //开户银行
                    this.formData.payAccountName = item.accountName;
                  }
                });
              }
            }
          });
    },
    payMoneyEvt() {
      //预付款
      // if (this.formData.payType == 2) {
      //   this.payAmount = (this.data.advancePaymentAmount*100 + this.transactionAmount*100)/100
      //   //全额付款
      // } else if (this.formData.payType == 1) {
      //   this.payAmount = (this.data.amount*100 + this.transactionAmount*100)/100
      // } else {
      //   this.payAmount = 0.0
      // }
       this.payAmount = Math.round(this.transactionAmount*100 + this.transactionPrice*100)/100
    },
    dialogSumbitR(){
      this.$router.push({name: 'myInvest'})
    },
    dialogSumbitL() {
      if(this.applayShow){
        this.applayShow = false
      }
    },
    newSaveAndSubmitBtn() {
      this.$refs.formRef.validate((v) => {
        if (v) {
          console.log(this.data);
          console.log(this.delistingData);

          // 提交接口
          if (this.isPromisePayed != 1 && this.formData.payMethod == 2) {
            if (
              !this.formData.payEvidences ||
              (this.formData.payEvidences && !this.formData.payEvidences.length)
            ) {
              return this.$message.error("请上传缴费凭证");
            }
          }
          if (this.formData.payMethod == 1 && !this.checked)
            return this.$message.error('请阅读并勾选付款协议')
          // (!this.formData.payBankAccount || !this.formData.payBankName)
          if (
              this.formData.payMethod == 1 &&
              (!this.formData.payBankAccount || !this.formData.payBankName)
          )
            return this.$message.error('请选择代收代付银行卡')
          this.formData = {
            ...this.formData,
            ...this.delistingData,
            listingApplyId: this.data.id,
            areaId: this.data.areaConfigId,
            feeType: this.data.tranferType == 1 ? "0" : "1",
            amount: this.payAmount,
          };
          // this.loading = true
          // this.$api.my.delistingOperate(this.formData).then((res) => {
          //   this.loading = false
          //   if(res.code == 1000){
          //     this.applayShow = true
          //     this.close()
          //     // this.$message.success("摘牌成功")
          //     // setTimeout(() => {
          //     //   this.close()
          //     //   this.$router.push({name: 'myInvest'})
          //     // },500)
          //
          //   }
          // });
          if(this.formData.payMethod == 2 && (!this.accountName || !this.bankAccount)) {
            return this.$message.error('当前区域未配置收款银行卡,暂不支持自行转账,请联系管理员')
          } else {
            this.payInfoSure = {
              accountName: this.accountName,
              bankAccount: this.bankAccount,
              amount: this.payAmount,
            }
          }
        }
      });
    },
    changeSelectBank(flag) {
      if (this.bankList && this.bankList.length > 0) {
        if (flag == "pay") {
          this.bankList.forEach((item) => {
            if (this.formData.payBankAccount == item.bankCard) {
              this.formData.payBankName = item.bankName;
              this.formData.payAccountName = item.accountName;
            }
          });
        } else {
          if (this.formData.bankAccount) {
            this.bankList.forEach((item) => {
              if (this.formData.bankAccount == item.bankCard) {
                this.formData.openBank = item.bankName;
              }
            });
          }
        }
      }
    },
    payFileNameEvt(v) {
      this.fileNameS = v;
    },
    close() {
      this.$emit("dialogCloses", false);
    },
    async delistingGetDetail() {
      this.loading = true;
      await this.$api.my
        .delistingGetDetail({ listingApplyId: this.data.id })
        .then((res) => {
          if (res.code === 1000) {
            this.isPromisePayed = res.data.isPromisePayed;
            this.transactionAmount = res.data.transactionAmount
            this.transactionPrice = res.data.transactionPrice
            this.formData.userType = res.data.userType + "";
            if (res.data.isPromisePayed == 1) {
              this.rules.needStat.required = false;
              this.formData.contactPhone = res.data.contactPhone;
              this.formData.legalPerson = res.data.legalPerson;
              this.formData.enterpriseName = res.data.enterpriseName;
              this.formData.registAddress = res.data.registAddress;
              this.formData.creditCode = res.data.creditCode;
              this.formData.bankAccount = res.data.bankAccount;
              this.formData.openBank = res.data.openBank;
              this.formData.bankCode = res.data.bankCode;
            }
            this.getBankList(); //获取代收代付银行卡列表
          }
        })
        .catch((error) => {})
        .finally(() => {
          this.loading = false;
        });
    },
    //查询当前企业是否可用其他方式摘牌
    async getAuthInfo() {
      if (this.formData.creditCode) {
        if (this.data.tranferType == 1) return; ///申请报价return
        this.loading = true;
        await this.$api.apply
          .getAuthInfo({
            areaConfigId: this.data.areaConfigId,
            unifiedCreditCode: this.formData.creditCode,
            type: 0,
          })
          .then((res) => {
            if (res.data.status != null) {
              this.applyStatus = res.data.status * 1;
            } else {
              this.applyStatus = 2;
            }
          })
          .catch((error) => {})
          .finally(() => {
            this.loading = false;
          });
      }
    },
    //获取自行转账的相关银行信息
    async getCompanyInfo() {
      await this.$api.my
        .getFeeItem({
          areaId: this.data.areaConfigId,
          feeType: this.data.tranferType == 1 ? "0" : "1",
        })
        .then((res) => {
          if (res.code === 1000) {
            if (res.data) {
              this.openBank = res.data.bankName;
              this.accountName = res.data.accountName;
              this.bankAccount = res.data.bankCard;
            }
          }
        });
    },
    // 重置信息
    changeRadio() {
      this.formData.contactPhone = "";
    },
  },
  watch: {
    fileUrl: {
      handler(newVal, oldVal) {
        if (newVal) {
          this.formData.payEvidences.push({
            url: newVal,
            name: this.fileNameS,
          });
          this.fileUrl = "";
          this.fileNameS = "";
        }
      },
    },
    delistingShow: {
      async handler(newVal, oldVal) {
        if (newVal) {
         await this.delistingGetDetail();
          this.getCompanyInfo(); //获取自行转账的相关银行信息
          this.payMoneyEvt()
        }
      },
    },
  },
};
</script>

<style lang="scss" scoped>
.btn {
  text-align: center;
  margin: auto;
  display: block;
}
</style>
